import React, { Component } from 'react';
import ReactPlayer from 'react-player'
import CSSModules from 'react-css-modules';
import style from './media-player.scss';
import { PlaybackControls, ProgressBar, VolumeSlider } from 'react-player-controls';
import { Row, Col, Icon } from '$common';

@CSSModules(style, { allowMultiple: true })
export default class MediaPlayer extends Component {
  state = {
    isPlayable: true,
    isPlaying: false,
    volume: 1,
    playbackRate: 1,
    playedSeconds: 0,
    duration: 0
  };

  constructor(props) {
    super(props);
  }

  get id() {
    this._id = this._id || 'player_wrapper_' + Math.floor(Math.random() * 100000000);
    return this._id;
  }

  componentDidMount() {
    if (document.querySelectorAll(`#${this.id}, #${this.id} *`).length > 0) {  
      [...document.querySelectorAll(`#${this.id}, #${this.id} *`)].map( item => {
        item.addEventListener('keydown', this.handleKeyPress.bind(this));
      })
    }
  }

  componentWillUnmount() {
    if (document.querySelectorAll(`#${this.id}, #${this.id} *`).length > 0) {  
      [...document.querySelectorAll(`#${this.id}, #${this.id} *`)].map( item => {
        item.removeEventListener('keydown', this.handleKeyPress.bind(this));
      })
    }
  }

  format(seconds) {
    const date = new Date(seconds * 1000)
    const hh = date.getUTCHours()
    const mm = date.getUTCMinutes()
    const ss = this.pad(date.getUTCSeconds())
    if (hh) {
      return `${hh}:${this.pad(mm)}:${ss}`
    }
    return `${mm}:${ss}`
  }

  pad(string) {
    return ('0' + string).slice(-2)
  }

  handleKeyPress(event) {
    switch (event.keyCode) {
      case 37:
        if (this.state.playedSeconds >= 5) {
          this.player.seekTo(this.state.playedSeconds - 5);
          this.setState({ playedSeconds: this.state.playedSeconds - 5 });
        }
      break;
      case 39:
        if ((this.state.duration - this.state.playedSeconds) >= 5) {
          this.player.seekTo(this.state.playedSeconds + 5)
          this.setState({ playedSeconds: this.state.playedSeconds + 5 });
        }
      break;
      case 32:
        if (this.state.isPlaying) {
          this.setState({ isPlaying: false })
        } else {
          this.setState({ isPlaying: true })
        }
        event.preventDefault();
        return false;
      break;
    }
  }

  render() {
    const { url, controls = true, height = '300px', onClick = () => {} } = this.props;

    return (
      <div styleName="root" tabIndex="1" onClick={(event) => onClick(event)} id={this.id}>
        <ReactPlayer
          ref={player => this.player = player}
          url={url}
          width="100%"
          height={height}
          playing={ this.state.isPlaying }
          style={{ background: '#333', borderRadius: '6px' }}
          onProgress={ e => this.setState({ playedSeconds: Math.round(e.playedSeconds) }) }
          onDuration={ duration => this.setState({ duration: Math.round(duration) }) }
          volume={this.state.volume}
          playbackRate={this.state.playbackRate}
        />
        {
          controls ? 
            <div className="player-controls">
              <Row>
                <Col md="1/10">
                  <PlaybackControls
                    isPlayable={this.state.isPlayable}
                    isPlaying={this.state.isPlaying}
                    onPlaybackChange={isPlaying => this.setState({ ...this.state, isPlaying })}
                    showNext={false}
                    showPrevious={false}
                  />
                </Col>
                <Col md="5/10">
                  <div styleName="progressbar-wrapper">
                    <span styleName="current-time">{this.format(this.state.playedSeconds)}</span>
                    <ProgressBar
                      totalTime={this.state.duration}
                      currentTime={this.state.playedSeconds}
                      isSeekable={true}
                      onSeek={time => this.player.seekTo(Math.round(time))}
                      onSeekStart={time => this.player.seekTo(Math.round(time))}
                      onSeekEnd={time => this.setState({ seeking: true })}
                    />
                    <span styleName="duration">{this.format(this.state.duration)}</span>
                  </div>
                </Col>
                <Col md="1/10">
                  {
                    this.state.playbackRate === 2 ? 
                      <span styleName={`playback-rate active`} onClick={ () => this.setState({ playbackRate: 1 })}>2x</span>
                   : <span styleName={`playback-rate`} onClick={ () => this.setState({ playbackRate: 2 })}>2x</span>
                  }
                </Col>
                <Col md="1/10">
                  {
                    this.state.playbackRate === 1.5 ? 
                      <span styleName={`playback-rate active`} onClick={ () => this.setState({ playbackRate: 1 })}>1.5x</span>
                   : <span styleName={`playback-rate`} onClick={ () => this.setState({ playbackRate: 1.5 })}>1.5x</span>
                  }
                </Col>
                <Col md="1/10">
                  {
                    this.state.playbackRate === 1.2 ? 
                      <span styleName={`playback-rate active`} onClick={ () => this.setState({ playbackRate: 1 })}>1.2x</span>
                   : <span styleName={`playback-rate`} onClick={ () => this.setState({ playbackRate: 1.2 })}>1.2x</span>
                  }
                </Col>
                <Col md="1/10">
                  <div styleName="volume-slider">
                    <span><Icon name="volume-up"/></span>
                    <VolumeSlider
                      isEnabled={true}
                      volume={this.state.volume}
                      onVolumeChange={volume => this.setState({ ...this.state, volume: volume >= 0 ? volume : 0 })} 
                    />
                  </div>
                </Col>
              </Row>
            </div>
          : ''
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/common/media-player.js